<div class="input-container">
  <div class="input-cell">
    <label *ngIf="label">{{ label }}</label>
    <span class="input-flex flex-right">
      <p-autoComplete
        [disabled]="disabled"
        [ngModelOptions]="{ standalone: true }"
        [(ngModel)]="item"
        [suggestions]="filteredItems"
        placeholder="Type to search an Organization"
        field="name"
        (completeMethod)="filter($event)"
        (onSelect)="onSelect($event)"
        styleClass="autocomplete-tile complete-input"
        inputStyleClass="complete-input"
      >
        <ng-template let-item pTemplate="item">
          {{ item.name }}
        </ng-template>
      </p-autoComplete>
    </span>
  </div>
</div>
